import { gql } from '@apollo/client'

/*
 * Server-built CSV (main app's recruiter schema — send with `context: { clientName: 'hostRecruiter' }`).
 * Returns at once with a `pending` file; a background job fills it, poll `exportFile(id)` for the URL.
 * `filters` is the list's own `searchXxx` filter object, camelCase, so the file matches the screen.
 */
export const EXPORT_CSV_FILE_MUTATION = gql`
	mutation exportCsvFile($name: String, $entityType: EntityTypeEnum!, $filters: JSON, $selectedFields: [String!], $entityIds: [String!]) {
		exportCsvFile(name: $name, entityType: $entityType, filters: $filters, selectedFields: $selectedFields, entityIds: $entityIds) {
			id
			status
		}
	}
`
